import { Decimal } from 'decimal.js'

//加法
export const decimal_NUM = (arr) => {
  let initial = 0
  arr.forEach(c => {
    c = Number(c) * 100000000000000
    initial = initial + Number(c)
  })
  return initial / 100000000000000
}

//减法
export const Number_SubAll = (arg1, arg2) => {
  // var re1, re2, m, n
  // try {
  //   re1 = arg1.toString().split('.')[1].length
  // } catch (e) {
  //   re1 = 0
  // }
  // try {
  //   re2 = arg2.toString().split('.')[1].length
  // } catch (e) {
  //   re2 = 0
  // }
  // m = Math.pow(10, Math.max(re1, re2))
  // n = (re1 >= re2) ? re1 : re2
  // return ((arg1 * m - arg2 * m) / m).toFixed(n)

  let res = new Decimal(arg1).sub(new Decimal(arg2))
  return Number(res)

}

// 解决问题：小数相加损失精度 解决办法：变成整数之后相加再回退小数位
export const add = (arr) => {
  // let len = arr.length,
  //   maxPlace = 0;
  //
  // for (let i=0; i<len; i++) {
  //   let current = arr[i].toString();
  //   if (current.indexOf('.') !==-1)  {
  //     maxPlace = current.split('.')[1].length > maxPlace ? current.split('.')[1].length : maxPlace;
  //   }
  // }
  //
  // let power = Math.pow(10, maxPlace+10);
  //
  // let sum = 0;
  // for (let i=0; i<len; i++) {
  //   sum += arr[i]*power;
  // }
  //
  // return sum/power;

  let sum = 0
  for(let i=0; i<arr.length; i++) {
    sum = new Decimal(sum).add(new Decimal(arr[i]))
  }

  return Number(sum)

}

export const mul = (num1, num2) => {
  if (parseFloat(num1).toString() == "NaN" || parseFloat(num2).toString() == "NaN") return;
  var m = 0, s1 = num1.toString(), s2 = num2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {
  }
  try {
    m += s2.split(".")[1].length
  } catch (e) {
  }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
